import { combineReducers } from 'redux';

import general, { type GeneralState } from './general';
import system, { type SystemState } from './system';
import toaster, { type ToasterState } from './toaster';
import user, { type UserState } from './user';

export interface RootState {
  system: SystemState;
  user: UserState;
  toaster: ToasterState;
  general: GeneralState; // <-- add this line if you have the type exported
}

export default combineReducers({
  user,
  system,
  toaster,
  general, // <-- add this
});
